import React, { useState } from "react";
import { updatePayoutById } from "../../../../../store/actions/payout";
import styles from "../styles.module.css";
import { toast } from "react-toastify";

const BankReferenceModal = ({
  data,
  payouts,
  setBankReferenceModal,
  setPayouts,
}) => {

  const [bankId, setBankId] = useState(data?.bankReferenceId || "");

  const handleClick = async () => {
    const result = await updatePayoutById(data?._id, {
      bankReferenceId: bankId,
    });

    if (result.success) {
      toast.success("Payout updated successfully");

      const index = payouts.findIndex((el) => el._id === data._id);
      if (index !== -1) {
        const updatedPayouts = [...payouts];
        updatedPayouts[index] = result.data;
        setPayouts(updatedPayouts);
      }

      setBankReferenceModal(false);
    } else {
      toast.error("Something went wrong! Please try again later.");
    }
  };

  return (
    <div className={styles.modalBackdrop}>
      <div
        className={styles.modal}
        style={{ width: "500px" }}>
        <div className={styles.modal_header}>
          <h1>Reference Details</h1>
          <i
            className={styles.closeBtn + " fas fa-close"}
            onClick={() => {
              setBankReferenceModal(false);
            }}></i>
        </div>

        <div className={styles.modal_body}>
          <p style={{ marginBottom: "1.5rem", color: "#64748b", fontSize: "0.95rem" }}>
            Add the bank transaction reference ID after completing the transfer to the teacher.
          </p>
          <div className={styles.inputFormat}>
            <input
              type='text'
              placeholder='Enter Bank Reference ID'
              value={bankId}
              required
              onChange={(e) => setBankId(e.target.value)}
            />
          </div>
        </div>

        <div style={{ marginTop: "2.5rem" }}>
          <button
            onClick={handleClick}
            className={styles.submitBtn}>
            Save Reference
          </button>
        </div>
      </div>
    </div>
  );
};

export default BankReferenceModal;
